module.exports = __webpack_public_path__ + "img/mbicon.f67fc43e.svg";